import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["mentionable"];
import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
export default class MentionsDropdownItem extends Component {
  view(vnode) {
    const _this$attrs = this.attrs,
      {
        mentionable
      } = _this$attrs,
      attrs = _objectWithoutProperties(_this$attrs, _excluded);
    const className = classList('MentionsDropdownItem', 'PostPreview', "MentionsDropdown-".concat(mentionable.type()));
    return m("button", Object.assign({
      className: className,
      type: "button"
    }, attrs), m("span", {
      className: "PostPreview-content"
    }, vnode.children));
  }
}
flarum.reg.add('flarum-mentions', 'forum/components/MentionsDropdownItem', MentionsDropdownItem);